import { navigateTo } from '@helpers';
import { OPERATOR_PANEL_INFORMATION_SCREENS, scheduledProductionOperationIdParam } from '@components/operatorPanel/constants/operatorPanel.constants';

import type { GoToLinkedNcFileParams } from '@components/search/operations/components/StartJobPopup/types';

// Navigates to the job's NC Programs tab with the just-linked file pre-selected (ncFileId param) and closes the modal.
export const goToLinkedNcFile = ({ productionOperationId, ncFileId, machineId, hide }: GoToLinkedNcFileParams) => {
  navigateTo(OPERATOR_PANEL_INFORMATION_SCREENS.Information, {
    screen: OPERATOR_PANEL_INFORMATION_SCREENS.NcFiles,
    params: { [scheduledProductionOperationIdParam]: productionOperationId, ncFileId, id: machineId },
  });
  hide();
};
